<template>
  <section class="place-list padding_20">
    <div class="common-search__header">
      <div class="common-search__title">场角色管理</div>
    </div>
    <div class="list">
      <el-button @click="showModal">添加用户</el-button>
    </div>
    <el-dialog width="70%" title="用户列表" :visible.sync="dialogVisible">
      <Search
        ref="placeSearch"
        :search-array="searchArray"
        @getData="getUserData"
      />
      <el-table :data="list" style="width: 100%" height="40vh">
        <el-table-column prop="realname" label="姓名" />
        <el-table-column prop="name" label="用户名" />
        <el-table-column prop="phone" label="手机号" width="170px" />
        <el-table-column prop="auth_groups" label="所属权限组">
          <template slot-scope="scope">
            <span v-for="(group, gi) in scope.row.auth_groups" :key="gi">
              {{ group.name
              }}<template v-if="gi < scope.row.auth_groups.length - 1"
                >,</template
              >
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="department" label="所属人事组" />
        <el-table-column prop="user_groups" label="所属用户组" />
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button @click="addUser(scope.row)" type="text" size="small"
              >添加</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination-right"
        :current-page="query.page"
        :page-sizes="[10, 20, 50, 100, 500, 1000]"
        :page-size="query.per_page"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-dialog>
    <div class="list">
      <el-table :data="userList" style="width: 100%">
        <template v-for="(ele, id) in columns">
          <el-table-column
            v-if="id < columns.length - 1"
            :key="id"
            :sortable="ele.sortable"
            :prop="ele.prop"
            :label="ele.label"
            :type="ele.type"
          >
          </el-table-column>
          <el-table-column
            v-else
            :key="id"
            fixed="right"
            label="操作"
            width="80"
          >
            <template slot-scope="scope">
              <el-button @click="delUser(scope.row)" type="text" size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </section>
</template>

<script>
import Search from '@/components/common/Search.vue'
import Pagination from '@/components/Pagination/index.vue'
import {
  queryPlaceUser,
  queryUser,
  addPlaceUser,
  delPlaceUser
} from '@/api/admin'

export default {
  components: {
    Search,
    Pagination
  },
  methods: {
    showModal() {
      this.dialogVisible = true
      this.fetchData()
    },
    fetchData() {
      let params = Object.assign({}, this.query)
      params = Object.keys(this.params || {}).reduce((t, c) => {
        if (this.params[c]) {
          t[c] = this.params[c]
        }
        return t
      }, params)
      Object.keys(params).forEach((p) => {
        if (!params[p] && params[p] !== 0) {
          delete params[p]
        }
      })
      queryUser(params).then((res) => {
        this.list = res.data.users
        this.totalCount = res.data.total
        // 如果分页条件大于总数了，再查询一次
        if (
          this.query.page > 1 &&
          (this.query.page - 1) * this.query.per_page >= this.totalCount
        ) {
          this.query.page -= 1
          this.fetchData()
        }
      })
    },
    handleSizeChange(val) {
      this.query.page = 1
      this.query.per_page = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.query.page = val
      this.fetchData()
    },
    async handleFetchUserList() {
      const res = await queryPlaceUser({
        project_id: this.$route.query.id
      })
      this.userList = res.data
    },
    getUserData(data) {
      this.query = {
        name: data.name,
        page: 1,
        per_page: 10
      }
      this.fetchData()
    },
    async addUser(row) {
      const data = {
        user_id: row.id,
        project_id: this.$route.query.id // 项目id, (place_id)
      }
      const res = await addPlaceUser(data)
      if (res) {
        this.$message({
          type: 'success',
          message: '添加成功!'
        })
      }
      this.dialogVisible = false
      this.handleFetchUserList()
    },
    delUser(row) {
      this.$confirm('此操作将删除当前用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delPlaceUser({
            id: row.id
          })
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.handleFetchUserList()
        })
        .catch(() => {
        })
    }
  },
  created() {
    // 调用接口
    this.handleFetchUserList()
  },
  data() {
    return {
      query: {
        page: 1,
        per_page: 10
      },
      totalCount: 0,
      list: null,
      dialogVisible: false,
      size: 20,
      page: 1,
      total: 0,
      columns: [
        {
          type: 'index',
          label: '序号',
          sortable: false
        },
        {
          prop: 'user_name',
          label: '用户名',
          sortable: false
        },
        {
          prop: 'user_realname',
          label: '姓名',
          sortable: false
        },
        {
          action: true,
          label: '操作'
        }
      ],
      searchArray: [
        {
          label: '用户名',
          props: 'name',
          type: 'input'
        }
      ],
      placeList: [],
      userList: []
    }
  }
}
</script>

<style scoped lang="scss">
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.my-label-tasks__header {
  margin-bottom: 10px;
}
.list {
  margin: 25px 0;
  box-sizing: border-box;
  padding: 20px;
  overflow: hidden;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.place_detail {
  color: #2c2c2e;
}
</style>
